export default "__VITE_ASSET__CqR7_5jl__"